module.exports = __webpack_public_path__ + "media/images/flags/32/Aland-1fd920204502781e4cc2f5ddb396d5b8.png";